/** TeamOnboardingGate's decision (#803), in its own module so the component file
 *  exports only a component (react-refresh) and the rule is tested without a DOM. */
function allowNoTeam(pathname: string) {
  return (
    pathname.startsWith("/join/") ||
    pathname === "/onboarding/team/new" ||
    // #1498: a driver with no team has their own runs, account and the agent page
    pathname === "/me" || pathname.startsWith("/me/") ||
    pathname === "/settings" || pathname === "/desktop"
  );
}

/** What the gate shows. The spinner is for
 *  the FIRST team load only; a background refetch keeps the page mounted. */
export function gateView(v: {
  signedIn: boolean; pathname: string; initialized: boolean; teamCount: number;
}): "page" | "spinner" | "me" {
  if (!v.signedIn || allowNoTeam(v.pathname)) return "page";
  // #1191: a page inside one team renders while teams load; the redirect below still
  // follows if there are none.
  if (!v.initialized) return /^\/teams\/[^/]+/.test(v.pathname) ? "page" : "spinner";
  return v.teamCount === 0 ? "me" : "page";
}
